import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ShareButton from '../components/ShareButton';
import SubjectPicker from '../components/SubjectPicker';

// Page QCM : la liste des sujets. Un clic sur un sujet ouvre ses QCM (QcmSubject).
export default function Qcm() {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch('/api/qcm/subjects')
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(setSubjects)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="section fade-in">
      <div className="section-head">
        <h2>qcm</h2>
        <span className="head-right">
          <span className="counter">{String(subjects.length).padStart(2, '0')} sujet{subjects.length > 1 ? 's' : ''}</span>
          <ShareButton variant="icon" title="QCM — Zahra's Learning" text="Des QCM pour tester vos connaissances, à jouer comme un jeu sur mobile" />
        </span>
      </div>

      {loading ? <div className="empty-state">chargement...</div> :
       error ? <div className="empty-state">impossible de charger les QCM pour le moment — réessayez dans un instant.</div> :
       subjects.length === 0 ? <div className="empty-state">rien encore ici ✦</div> : (
        <>
          <p className="qcm-intro-line">Choisissez un sujet pour voir ses QCM.</p>
          <SubjectPicker subjects={subjects.map(s => ({ id: s.id, name: s.name, count: s.quizzes.length }))} allHref="/qcm" hrefFor={id => `/qcm/sujet/${id}`} unit="QCM" />
          <div className="qcm-subject-grid">
            {subjects.map((s, i) => {
              const nq = s.quizzes.reduce((n, q) => n + q.question_count, 0);
              return (
                <Link key={s.id} to={`/qcm/sujet/${s.id}`} className={`qcm-subject-card tone-${i % 4}`}>
                  <span className="qcm-subject-card-count">{s.quizzes.length} QCM · {nq} question{nq > 1 ? 's' : ''}</span>
                  <h3>{s.name}</h3>
                  {s.description && <p>{s.description}</p>}
                  <span className="qcm-subject-card-go">voir les QCM →</span>
                </Link>
              );
            })}
          </div>
        </>
      )}
    </section>
  );
}
